import { memo } from 'react';
import { Typography } from 'antd';

import styles from './AuctionDescription.module.css';

const { Title } = Typography;

interface AuctionDescriptionProps {
  description: string;
}

function AuctionDescription({ description }: AuctionDescriptionProps) {
  const isGoogleDocsLink = (link: string) => {
    return /^https:\/\/docs\.google\.com\/document\/d\/e\/[\w-]+\/pub/.test(link);
  };

  return (
    <>
      <Title level={4}>상품 상세</Title>
      {isGoogleDocsLink(description) ? (
        <a href={description} target="_blank" rel="noopener noreferrer">
          {description}
        </a>
      ) : (
        <p className={styles['pre-wrap']}>{description}</p>
      )}
    </>
  );
}

export default memo(AuctionDescription);
